import React, { lazy } from 'react';
import { FileSearchIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const previewPages = [{
  src: 'https://cdn.magicpatterns.com/uploads/icqwJcoQdBV6uV7djFvVoY/WhatsApp_Image_2026-07-09_at_17.46.36.jpg',
  alt: 'Checklist Antes de Demandar',
  label: 'Checklist procesal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5WRNsdoNABP8ZzRiQz31zm/WhatsApp_Image_2026-07-09_at_17.46.35_(3).jpg',
  alt: 'Modelo de rechazo de sanciones disciplinarias',
  label: 'Telegramas laborales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4BM6cAC8RU3PLQN4jyi1qt/WhatsApp_Image_2026-07-09_at_17.46.35_(2).jpg',
  alt: 'Modelo de demanda por trabajo no registrado',
  label: 'Demandas editables'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bthhCwXoqyrX3U2nmMta31/WhatsApp_Image_2026-07-09_at_17.46.35_(1).jpg',
  alt: 'Formularios de licencia, renuncia y reintegro',
  label: 'Formularios laborales'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eCqAaoLiNnJKH5FybTZd7k/WhatsApp_Image_2026-07-09_at_17.46.35.jpg',
  alt: 'Recibo de haberes y constancias laborales',
  label: 'Documentación lista'
}];
export function ContentPreview() {
  return <section className="border-y border-white/10 bg-charcoal px-5 py-14 md:px-8 md:py-20" data-id="element-45">
      <div className="mx-auto max-w-6xl" data-id="element-46">
        <FadeIn className="mx-auto max-w-2xl text-center" data-id="element-47">
          <div className="mx-auto flex w-fit items-center gap-2 text-accent" data-id="element-48">
            <FileSearchIcon size={18} aria-hidden="true" data-id="element-49" />
            <p className="text-sm font-bold uppercase tracking-[0.18em]" data-id="element-50">
              Vista Previa del Contenido
            </p>
          </div>
          <h2 className="mt-3 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-51">
            Conocé el material antes de acceder
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-stone-400 md:text-base" data-id="element-52">
            Una selección de páginas del Tratado para que conozcas la calidad,
            estructura y nivel profesional del material antes de acceder.
          </p>
        </FadeIn>

        <div className="mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-4 md:grid md:grid-cols-5 md:overflow-visible md:pb-0" data-id="element-53">
          {previewPages.map((page, index) => <FadeIn key={page.label} delay={index * 0.05} className="w-52 shrink-0 snap-center md:w-auto" data-id="element-54">
              <figure className="overflow-hidden border border-white/10 bg-ink p-2 shadow-[0_12px_26px_rgba(0,0,0,0.22)]" data-id="element-55">
                <img src={page.src} alt={page.alt} className="aspect-[0.72] w-full object-cover object-top" loading="lazy" data-id="element-56" />
                <figcaption className="border-t border-white/10 px-1 pb-1 pt-3 text-center text-xs font-semibold text-stone-300" data-id="element-57">
                  {page.label}
                </figcaption>
              </figure>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}